import { handleFilterUpdateInUserContext, resetFilterHandler } from 'common/pagination';
import { DEFAULT_FILTERS } from '../constants/filterOptions';

// With FILTER_TYPES aligned to backend keys, we can persist directly.

export const updateUserPreferencesForFilter = (userContext, filterKey, value, excludeFromLoading = true) => {
  if (!userContext?.firmDetails || !filterKey) return;
  handleFilterUpdateInUserContext(userContext, 'filters', 'calender', null, filterKey, value, excludeFromLoading);
};

export const updateUserPreferencesForFilters = (userContext, filters, excludeFromLoading = true) => {
  if (!userContext?.firmDetails || !filters) return;
  Object.entries(filters).forEach(([filterKey, value]) => {
    updateUserPreferencesForFilter(userContext, filterKey, value, excludeFromLoading);
  });
};

export const resetFilterPreferences = (userContext, excludeFromLoading = true) => {
  if (!userContext?.firmDetails) return;

  // Preserve firm_user (selected users) when resetting filters
  const currentFirmUser = userContext?.firmDetails?.user_preferences?.filters?.calender?.firm_user;
  const resetData = {
    ...DEFAULT_FILTERS,
    ...(currentFirmUser !== undefined && { firm_user: currentFirmUser }), // Preserve users selection
  };

  resetFilterHandler(userContext, 'filters', 'calender', resetData, excludeFromLoading);
};

// Team calendars (selected users) persistence
export const updateFirmUserPreference = (userContext, userIds = [], excludeFromLoading = true) => {
  if (!userContext?.firmDetails) return;
  handleFilterUpdateInUserContext(userContext, 'filters', 'calender', null, 'firm_user', userIds, excludeFromLoading);
};
